module.exports = __webpack_public_path__ + "assets/icon_arrows.8f34422b.svg";